import React from 'react';

export default function CommentsSection({ generalComment }) {
  return (
    <>
      <p className="rc-section-title">Comments</p>
      <div className="rc-comments">
        <div className="rc-comment-block">
          <div className="rc-comment-role">Class Teacher's Comment</div>
          <div className="rc-comment-text">
            {generalComment?.class_teacher_comment || ''}
          </div>
        </div>
        <div className="rc-comment-block">
          <div className="rc-comment-role">Head Teacher's Comment</div>
          <div className="rc-comment-text">
            {generalComment?.headteacher_comment || ''}
          </div>
        </div>
      </div>
    </>
  );
}
